import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { DataProvider } from "./context/DataContext";
import { AuthProvider } from "./context/AuthContext";
import WebsiteLayout from "./components/layout/WebsiteLayout";
import Home from "./pages/Home";
import Lab from "./pages/Lab";
import Staffing from "./pages/Staffing";
import Software from "./pages/Software";
import Valuation from "./pages/Valuation";
import Blog from "./pages/Blog";
import Careers from "./pages/Careers";
import Contact from "./pages/Contact";
import NotFound from "./pages/NotFound";
import AdminLogin from "./admin/Login";
import RequireAuth from "./admin/RequireAuth";
import AdminLayout from "./admin/AdminLayout";
import DashboardTab from "./admin/tabs/DashboardTab";
import AnalyticsTab from "./admin/tabs/AnalyticsTab";
import ProductsTab from "./admin/tabs/ProductsTab";
import OrdersTab from "./admin/tabs/OrdersTab";
import LeadsTab from "./admin/tabs/LeadsTab";
import KanbanTab from "./admin/tabs/KanbanTab";
import JobsTab from "./admin/tabs/JobsTab";
import BlogTab from "./admin/tabs/BlogTab";
import TestimonialsTab from "./admin/tabs/TestimonialsTab";
import TeamTab from "./admin/tabs/TeamTab";
import CertsTab from "./admin/tabs/CertsTab";
import ImageManagerTab from "./admin/tabs/ImageManagerTab";
import WhatsAppTab from "./admin/tabs/WhatsAppTab";
import SettingsTab from "./admin/tabs/SettingsTab";

export default function App() {
  return (
    <DataProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<WebsiteLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/lab" element={<Lab />} />
              <Route path="/staffing" element={<Staffing />} />
              <Route path="/it" element={<Software />} />
              <Route path="/valuation" element={<Valuation />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/careers" element={<Careers />} />
              <Route path="/contact" element={<Contact />} />
            </Route>

            <Route path="/admin/login" element={<AdminLogin />} />
            <Route element={<RequireAuth />}>
              <Route path="/admin" element={<AdminLayout />}>
                <Route index element={<Navigate to="dashboard" replace />} />
                <Route path="dashboard" element={<DashboardTab />} />
                <Route path="analytics" element={<AnalyticsTab />} />
                <Route path="products" element={<ProductsTab />} />
                <Route path="orders" element={<OrdersTab />} />
                <Route path="leads" element={<LeadsTab />} />
                <Route path="kanban" element={<KanbanTab />} />
                <Route path="jobs" element={<JobsTab />} />
                <Route path="blog" element={<BlogTab />} />
                <Route path="testimonials" element={<TestimonialsTab />} />
                <Route path="team" element={<TeamTab />} />
                <Route path="certs" element={<CertsTab />} />
                <Route path="images" element={<ImageManagerTab />} />
                <Route path="whatsapp" element={<WhatsAppTab />} />
                <Route path="settings" element={<SettingsTab />} />
              </Route>
            </Route>

            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </DataProvider>
  );
}
